import { getParsedLocalStorageItem, setLocalStorageItem } from 'src/services/storage/local';
import { ERROR_PREFIXES } from 'src/common/constants';
import { API } from '../REST';
import { RESPONSE_TYPES } from '../REST/constants';
import { isBadStatus } from '../REST/utils/isBadStatus';

const MaxService = API.max;

export type CMSMarkdown = {
    id: string;
    content: string;
};

type GetMarkdownCMSDocumentResponse = {
    content: string;
};
export const MARKDOWN_CACHE_KEY = 'zhl.markdown.cache';
export const getMarkdownCMSDocument = async (id: string): Promise<CMSMarkdown> => {
    const cache =
        getParsedLocalStorageItem<Record<string, CMSMarkdown>>(MARKDOWN_CACHE_KEY) ??
        ({} as Record<string, CMSMarkdown>);
    if (cache[id]) {
        return cache[id];
    }

    try {
        const response = await MaxService.GET<GetMarkdownCMSDocumentResponse>({
            action: '/getMarkdownCMSDocument',
            input: {
                id,
            },
        });

        if (response.type === RESPONSE_TYPES.NETWORK_ERROR || isBadStatus(response.statusCode)) {
            throw new Error(
                `${ERROR_PREFIXES.MAX_API} Fetching markdown from MAX service failed to fetch for ${id}, statusCode: ${
                    response.type === RESPONSE_TYPES.NETWORK_ERROR ? null : response.statusCode
                }`
            );
        }

        const { content } = response.data;

        const markdown: CMSMarkdown = {
            id,
            content,
        };

        setLocalStorageItem(MARKDOWN_CACHE_KEY, {
            ...cache,
            [id]: markdown,
        });
        return markdown;
    } catch (error) {
        const failedMarkdown: CMSMarkdown = {
            id,
            content: '',
        };
        return failedMarkdown;
    }
};
